//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from "vuex";

export default {
  name: "Loader",
  data() {
    return {
      done: false
    }
  },
  computed: {
    ...mapGetters(['loading'])
  }
};
